import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import { makeStyles } from "@mui/styles";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getEntityMappingList } from "../../redux/actions/getEntityMappingListAction";
import { getEntityTypeList } from "../../redux/actions/getEntityTypeListAction";
import { createEntityMappingList } from "../../redux/actions/createEntityMappingAction";
import { deleteEntityMappingList } from "../../redux/actions/deleteEntityMappingAction";
import { addOrUpdateEntityTypeList } from "../../redux/actions/addOrUpdateEntityTypeListAction";
import { getLoadLimitList } from "../../redux/actions/getLoadLimitListAction";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import DeleteIcon from "@mui/icons-material/Delete";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminMappingEntityType = () => {
	const [entityType, setEntityType] = useState("");
	const [walletOwnerId, setWalletOwnerId] = useState("");
	const [page, setPage] = useState(0);
	const [Open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);
	const [getEntityTypeStatus, setGetEntityTypeStatus] = useState(false);
	const [getEntityTypeResArray, setGetEntityTypeResArray] = useState([]);
	const [getEntityMappingStatus, setGetEntityMappingStatus] = useState(false);
	const [getEntityMappingResArray, setGetEntityMappingResArray] = useState([]);
	const [createEntityMappingStatus, setCreateEntityMappingStatus] =
		useState("");
	const [createEntityMappingResArray, setCreateEntityMappingResArray] =
		useState([]);
	const [deleteEntityMappingStatus, setDeleteEntityMappingStatus] =
		useState("");
	const [deleteEntityMappingResArray, setDeleteEntityMappingResArray] =
		useState([]);
	const [mappingId, setMappingId] = useState("");

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [walletOwnerIdS, setWalletOwnerIdS] = useState("");
	const [entityTypes, setEntityTypes] = useState("");
	const [addOpen, setAddOpen] = React.useState(false);

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const getEntityTypeListRes = useSelector(
		({ getEntityTypeList }) => getEntityTypeList
	);

	const getEntityMappingListRes = useSelector(
		({ getEntityMappingList }) => getEntityMappingList
	);

	const createEntityMappingRes = useSelector(
		({ createEntityMapping }) => createEntityMapping
	);

	const deleteEntityMappingRes = useSelector(
		({ deleteEntityMapping }) => deleteEntityMapping
	);

	const handleNoticationClose = () => {
		setCreateEntityMappingResArray([]);
		setDeleteEntityMappingResArray([]);
		setEntityType("");
		setWalletOwnerId("Select Level");
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "EntityType") {
			setEntityType(value == "Select Level" ? "" : value);
		}

		if (name === "walletOwnerId") {
			setWalletOwnerId(value);
		}
		if (name === "EntityTypeS") {
			setEntityTypes(value == "Select Level" ? "" : value);
		}

		if (name === "walletOwnerIdS") {
			// setWalletOwnerIdS(value);
			setWalletOwnerIdS(value == "Select Level" ? "" : value);
		}
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						// adminId: "2"
						adminId: val.adminIDS

					}
				},
				authToken
			)
		);
	};
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameListReq();
			getEntityTypeListReq();
			getEntityMappingListReq();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const getEntityListStatusFunc = () => {
		if (getEntityTypeStatus) {
			if (getEntityTypeListRes.data.status == "success") {
				setGetEntityTypeResArray([].concat(getEntityTypeListRes.data.roleList));
			}
			if (getEntityTypeListRes.data.status == "failed") {
				setGetEntityTypeResArray(getEntityTypeListRes.data);
				if (
					getEntityTypeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityTypeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getEntityListStatusFunc();
	}, [getEntityTypeListRes.data.status]);

	const getEntityTypeListReq = () => {
		setGetEntityTypeStatus(true);
		dispatch(
			getEntityTypeList(
				{
					ownerMasterRequestVO: {
						// adminId: 2,
						adminId: val.adminIDS,

						entityType: entityType
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getEntityTypeListReq();
	// }, []);

	const getEntityMappingListReq = () => {
		setOpen(false);
		setGetEntityMappingStatus(true);
		setIsLoading(true);
		dispatch(
			getEntityMappingList(
				{
					// adminId: 2,
					adminId: val.adminIDS,

					walletOwnerId: walletOwnerIdS.split("-")[0],
					entityType: entityTypes
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getEntityMappingListReq();
	// }, []);

	const getEntityMappingStatusFunc = () => {
		if (getEntityMappingStatus) {
			if (getEntityMappingListRes.data.status == "success") {
				setGetEntityMappingResArray(
					[].concat(getEntityMappingListRes.data.roleList)
				);
				setIsLoading(false);
			}
			if (getEntityMappingListRes.data.status == "failed") {
				setGetEntityMappingResArray(getEntityMappingListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"Failed",
					getEntityMappingListRes.data.description ||
					getEntityMappingListRes.description
				);
				if (
					getEntityMappingListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getEntityMappingListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getEntityMappingListRes.data.status == "NOT FOUND") {
				setGetEntityMappingResArray(getEntityMappingListRes.data);
				setIsLoading(false);
				NotificationPopups(
					"error",
					"NOT FOUND",
					getEntityMappingListRes.data.description ||
					getEntityMappingListRes.description
				);
			}
		}
	};

	useEffect(() => {
		getEntityMappingStatusFunc();
	}, [getEntityMappingListRes.data.status]);

	useEffect(() => {
		if (getEntityMappingListRes.data.status == "success") {
			setPage(0);
		}
	}, [getEntityMappingListRes.data.status]);

	const createEntityMappingReq = () => {
		setCreateEntityMappingStatus(true);
		const createMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				ownerID:
					walletOwnerId == "Select Level" ? "" : walletOwnerId.split("-")[0],
				entityType: entityType == "Select Level" ? "" : entityType
			}
		};
		dispatch(createEntityMappingList(createMappingReq, authToken));
		// console.log("reqqq", createMappingReq)
	};

	const createEntityMappingStatusFunc = () => {
		console.log(createEntityMappingRes, "/////////////////////////");
		if (createEntityMappingStatus) {
			if (createEntityMappingRes.data.status == "success") {
				setCreateEntityMappingResArray(createEntityMappingRes.data);
				setNotificationOpen(true);
				getEntityMappingListReq();
			}
			if (createEntityMappingRes.data.status == "failed") {
				setCreateEntityMappingResArray(createEntityMappingRes.data);
				setNotificationOpen(true);
				if (
					createEntityMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createEntityMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createEntityMappingRes.data.status == "INVALID REQUEST") {
				setCreateEntityMappingResArray(createEntityMappingRes.data);
				setNotificationOpen(true);
			}
		}
	};

	useEffect(() => {
		createEntityMappingStatusFunc();
	}, [createEntityMappingRes.data.status]);

	const deleteEntityMappingReq = () => {
		setDeleteEntityMappingStatus(true);
		const deleteMappingReq = {
			ownerMasterRequestVO: {
				// adminId: 2,
				adminId: val.adminIDS,

				mappingId: mappingId
			}
		};
		dispatch(deleteEntityMappingList(deleteMappingReq, authToken));
	};

	const deleteEntityMappingStatusFunc = () => {
		if (deleteEntityMappingStatus) {
			if (deleteEntityMappingRes.data.status == "success") {
				setDeleteEntityMappingResArray(deleteEntityMappingRes.data);
				setNotificationOpen(true);
				getEntityMappingListReq();
			}
			if (deleteEntityMappingRes.data.status == "failed") {
				setDeleteEntityMappingResArray(deleteEntityMappingRes.data);
				setNotificationOpen(true);
				if (
					deleteEntityMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteEntityMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		deleteEntityMappingStatusFunc();
	}, [deleteEntityMappingRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setOpen(false);
		setAddOpen(false);
	};

	const deleteEntity = (mappingid) => {
		setMappingId(mappingid);
		setOpen(true);
	};
	const addRole = () => {
		// setWalletOwnerId('')
		setWalletOwnerId('')
		setEntityType('')
		setAddOpen(true);
	};
	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						style={{ padding: "25px", justifyContent: "right" }}
						spacing={2}
					>

						<Grid item md={2} sm={12} xs={12} lg={2}>


							<CustomButton
								style={{
									padding: "8px",
									width: "80px"
								}}
								onClick={() => addRole()}

							>
								Create
							</CustomButton>

						</Grid>

					</Grid>

					{/* <DialogTitle>Creating Mapping</DialogTitle> */}
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"
								type="text"
								label="Owner ID"
								fullWidth={true}
								name="walletOwnerIdS"
								value={walletOwnerIdS || "Select Level"}
								// defaultValue={"Select Level" || walletOwnerIdS}
								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Owner ID
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Entity Type"
								fullWidth={true}
								name="EntityTypeS"
								variant="standard"

								value={entityTypes || "Select Level"}
								// defaultValue={"Select Level" || entityTypes}


								onChange={handleChange}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Entity Type
								</MenuItem>
								{getEntityTypeListRes.data.roleList &&
									getEntityTypeResArray.map((x) => (
										<MenuItem value={x.entityType}>{x.entityType}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								// onClick={createEntityMappingReq}
								onClick={getEntityMappingListReq}
							>
								Search
							</Button>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getEntityMappingResArray.length == undefined ||
					!getEntityMappingStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mapping ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Owner Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Entity Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Creation Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getEntityMappingResArray &&
											[]
												.concat(getEntityMappingResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.operationId}
														</TableCell>
														<TableCell align="center">
															{row.walletOwnerName}
														</TableCell>
														<TableCell align="center">{row.role}</TableCell>
														<TableCell align="center">
															{row.creationTime}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => deleteEntity(row.operationId)}
															>
																<DeleteIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getEntityMappingResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>Create Mapping</DialogTitle>
						<DialogContent>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									select
									required
									size="small"
									color="primary"
									autoFocus={true}
									variant="standard"
									type="text"
									label="Owner ID"
									fullWidth={true}
									name="walletOwnerId"
									value={walletOwnerId || "Select Level"}
									// defaultValue={"Select Level" || walletOwnerIdS}
									onChange={handleChange}
								>
									<MenuItem value="Select Level" selected="Select Level">
										Select Owner ID
									</MenuItem>
									{getWalletOwnerIdRes.data.ownerList &&
										getWalletOwnerIdResArray.map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
							</Grid>
							<Grid item xs={12} sm={6} md={4} lg={3}>
								<TextField
									select
									required

									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Entity Type"
									fullWidth={true}
									name="EntityType"
									variant="standard"

									value={entityType || "Select Level"}
									// defaultValue={"Select Level" || entityTypes}


									onChange={handleChange}
								>
									<MenuItem value="Select Level" selected="Select Level">
										Select Entity Type
									</MenuItem>
									{getEntityTypeListRes.data.roleList &&
										getEntityTypeResArray.map((x) => (
											<MenuItem value={x.entityType}>{x.entityType}</MenuItem>
										))}
								</TextField>
							</Grid>

							<DialogActions style={{ padding: "14px" }}>
								<Button
									style={{
										backgroundColor: "#fff",
										color: "#000"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</Button>
								<Button
									style={{
										marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white",
										// marginTop: "9px"
									}}
									variant="contained"
									onClick={createEntityMappingReq}
								>
									Create
								</Button>

							</DialogActions>
						</DialogContent>
					</Dialog>
				</div>


				<div>
					<Dialog open={Open} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
						<DialogActions className="p-3">
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								No
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={deleteEntityMappingReq}
							>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{createEntityMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createEntityMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createEntityMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createEntityMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createEntityMappingResArray.status == "INVALID REQUEST" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createEntityMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteEntityMappingResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteEntityMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteEntityMappingResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteEntityMappingResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminMappingEntityType;
